import { useT } from '@kmgestao/i18n';
import { Card, CardContent, CardHeader, CardTitle, PageContainer } from '@kmgestao/ui';

import { useAiKpis } from '../../../features/ai-analytics/index.js';
import { SuperadminShell } from '../SuperadminShell.js';

import { CallsChart } from './CallsChart.js';
import { DashboardHero } from './DashboardHero.js';
import { KpiCards } from './KpiCards.js';
import { ModulesCard } from './ModulesCard.js';
import { ProvidersCard } from './ProvidersCard.js';
import { RecentErrorsCard } from './RecentErrorsCard.js';

const PERIOD_DAYS = 30;

export function SuperadminAiDashboardPage() {
  const { t } = useT('dashboard');
  const query = useAiKpis(PERIOD_DAYS);

  return (
    <SuperadminShell>
      <PageContainer>
        <DashboardHero
          summary={query.data?.summary}
          generatedAt={query.data?.generatedAt}
          periodDays={PERIOD_DAYS}
        />

        {query.isError && !query.data ? (
          <Card className="border-destructive/40">
            <CardHeader>
              <CardTitle className="text-destructive">{t('states.loadErrorTitle')}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 text-sm text-muted-foreground">
              <p>{t('states.loadErrorDescription')}</p>
              <p className="font-mono text-xs text-destructive/90">{query.error.message}</p>
            </CardContent>
          </Card>
        ) : null}

        <KpiCards summary={query.data?.summary} loading={query.isLoading} />

        <div className="grid gap-6 xl:grid-cols-[minmax(0,1.65fr)_minmax(0,1fr)]">
          <CallsChart
            points={query.data?.daily}
            periodDays={PERIOD_DAYS}
            loading={query.isLoading}
          />
          <ModulesCard
            modules={query.data?.topModules}
            totalCalls={query.data?.summary.callsTotal}
            loading={query.isLoading}
          />
        </div>

        <div className="grid gap-6 xl:grid-cols-2">
          <ProvidersCard
            providers={query.data?.providers}
            totalCalls={query.data?.summary.callsTotal}
            loading={query.isLoading}
          />
          <RecentErrorsCard errors={query.data?.recentErrors} loading={query.isLoading} />
        </div>
      </PageContainer>
    </SuperadminShell>
  );
}
